import { useContext } from 'react';
import { Box, Alert, Button } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import { hasCompletedPersonalInfo } from '../utils/profileValidation';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../components/Dashboard';

const DashboardPage = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const isProfileIncomplete = user && !hasCompletedPersonalInfo(user);

    return (
        <Box>
            {isProfileIncomplete && (
                <Alert 
                    severity="warning" 
                    sx={{ 
                        mb: 2, 
                        mx: { xs: 2, md: 4 }, 
                        mt: { xs: 2, md: 4},
                        backgroundColor: '#fff7ed', 
                        color: '#9a3412',
                        border: '1px solid #ffedd5',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    action={
                        <Button 
                            color="inherit" 
                            size="small" 
                            onClick={() => navigate('/profile')}
                            sx={{ fontWeight: 600 }}
                        >
                            Complete Profile
                        </Button>
                    }
                >
                    Your profile is incomplete. Please complete your profile to apply for jobs and get better recommendations.
                </Alert>
            )}
            <Dashboard />
        </Box>
    );
};

export default DashboardPage;